<template>
    <el-card :class="['box-card', invoiceLabelName === 'CBS' && 'CBS-invoice']"  v-if="show">
        <div slot="header" class="clearfix">
            <span>发票内容</span>
        </div>
        <m-pane
            ref="tablePage"
            class="tablePage"
            :config="config"
            :totalData="totalData"
            :pageTotal="pageTotal"
            :loading="loading"
            pageID="InvoiceContentTable"
            :currentPage="currentPage"
            @row-db-click="handleRowDBClick"
            @row-click="handleRowClick"
            @add-btn="addVerify(handleAdd)"
            @save-btn="handleSaves"
            @export-btn="handleExport"
            @upload-btn="handleUpload"
            @del-btn="handleDelete"
            @pageChange="handlePageChange"
            @sizeChange="handleSizeChange"
            @selectChange="handleSelectChange"
            @page-click="handlePageClick"
            @element-change="handleChange"
        ></m-pane>
        <upload-temp ref="uploadInvoiceContent" :http-request="submitUpload" v-show="false"></upload-temp>
    </el-card>
</template>

<script>
import mPane from '@/modules/transport/bms/components/Table/Index.vue';
import UploadTemp from '../../UploadTemp.vue';
import {
    extsysInvoiceInfoQuery,
    saveExtsysInvoiceInfo,
    deleteExtsysInvoiceInfo,
    exportExtsysInvoiceInfo,
    importExtsysInvoiceInfo
} from '@/modules/transport/bms/api/invoiceManageApi.js';
import { getControlParam } from '@/modules/transport/bms/api/common.js';
import editTableMixin from '@/modules/transport/bms/mixins/editTableMixin.js';
import invoiceMixin from '../invoiceMixin';
import baseConfig, { columnMap, showActionBar, saveDataTemp } from './config.js';
import { mergeMatchedKeys } from '@/modules/transport/bms/utils/common.js';
export default {
    name: 'InvoiceContentTable',
    mixins: [editTableMixin, invoiceMixin],
    components: { mPane, UploadTemp },
    props: {
        jobId: {
            type: [String, Number]
        },
        makeInvoiceStatus: {
            type: [String, Number]
        },
        invoiceLabel: {
            type: [String]
        },
        apApplyNo: {
            type: [String]
        },
        openInvoiceType: {
            type: [String]
        }
    },
    data() {
        return {
            columnMap,
            config: baseConfig,
            show: false,
            transportInfo: {},
            hasData: false,
            allTableData: [], // 全量发票内容数据预览用
            showActionBar,
            curRowSnapshoot: null, // 当前行的快照
            addressKeywords: '省,市,区,县,街,路,村,乡,镇,道,巷,号,洲' // 地址关键字
        };
    },
    watch: {
        totalData: {
            deep: true,
            immediate: true,
            handler: function () {
                this.addressCascaderPopoverPlacementRefresh();
            }
        },
        makeInvoiceStatus: {
            immediate: true,
            handler(newValue) {
                this.setReadOnly([10, '10'].includes(newValue));
            }
        }
    },
    methods: {
        // 查询发票内容执行
        queryListExecute({ params, successCallback }) {
            if (!this.jobId) return;
            this.loading = true;
            params.sourceJobId = this.jobId;
            this.openInvoiceType && (params.openInvoiceType = this.openInvoiceType); // 开票类型
            extsysInvoiceInfoQuery(params).then(res => {
                if (res && +res.code === 0) {
                    res.data.list.forEach(el => {
                        el.rentStartAndEndDate = [el.rentStartDate, el.rentEndDate];
                        el.id = el.jobId;
                        if (this.invoiceLabelName === 'REBLS') {
                            // 处理不动产地址回显字符串格式
                            el.subStr2 = el.subStr2 ? el.subStr2.split(',') : [];
                            el.detailedAddress = el.realEstateAddress.includes(',') ?
                                el.realEstateAddress.split(',')[el.realEstateAddress.split(',').length - 1] :
                                '';
                            el.realEstateAddress = el.realEstateAddress.includes(',') ?
                                el.realEstateAddress.split(',')[0].replace(/&/g, ' / ') :
                                '';
                        };
                    });
                    this.hasData = res.data.list && !!res.data.list.length;
                    this.selected = [];
                    this.originalData = JSON.parse(JSON.stringify(res.data.list));
                    successCallback(res);
                }
            }).finally(() => {
                this.loading = false;
            });
            extsysInvoiceInfoQuery({ ...params, pageNo: 1, pageSize: 9999 }).then(res => {
                if (res && +res.code === 0) {
                    this.allTableData = res.data.list;
                }
            });
        },
        addVerify(callback) {
            if (!this.isNewState(this.makeInvoiceStatus)) return;
            if (this.invoiceLabelName === 'CBS') {
            } else if (this.invoiceLabelName === 'REBLS' && this.totalData.length >= 1) {
                return this.$message.warning('只能新增一条不动产经营租赁发票内容!');
            }
            this.curRowSnapshoot = null;
            callback && callback();
        },
        checkPlaceNameFn(str) {
            const keywords = this.addressKeywords.split(',');
            return keywords.some(el => str.includes(el));
        },
        // 验证地址信息做关键字限制
        checkAddressKeywordsFn({ address, detailedAddress }) {
            const [ province, city ] = address.split('&');
            const provinceKeywords = [ '省', '自治区', '特别行政区', '特区', '北京市', '天津市', '上海市', '重庆市' ];
            // const elseProvinceKeywords = [ '香港特别行政区', '澳门特别行政区', '台湾省', '香港特区', '澳门特区' ];
            const cityKeywords = [ '市', '盟', '自治州', '地区', '区' ];
            const detailDddressKeywords = [ '街', '路', '村', '乡', '镇', '道', '巷', '号' ];
            const provinceErrMsg = '不动产坐落地址（省）：必须以省、自治区、特别行政区、北京市、天津市、上海市、重庆市任意一个关键词结尾!';
            const cityErrMsg = '不动产坐落地址（市）：必须以市、盟、自治州、地区、区任意一个关键词结尾!';
            const detailDddressErrMsg = '不动产详细地址：必须包含街、路、村、乡、镇、道、巷、号等任意一个关键词!';

            const checkKeyeywordsFn = (str, keywords = [], errMsg = '') => {
                const regex = new RegExp('(' + keywords.join('|') + ')$', 'i');
                const flag = regex.test(str);
                if (!flag && errMsg) this.$message.warning(errMsg);
                return flag;
            };
            if (!checkKeyeywordsFn(province, provinceKeywords, provinceErrMsg)) return false;
            if (!checkKeyeywordsFn(city, cityKeywords, cityErrMsg)) return false;
            if (!(detailDddressKeywords.some(el => detailedAddress.includes(el)))) return (this.$message.warning(detailDddressErrMsg) && false);
            return true;
        },

        // 保存发票内容执行
        saveTableExecute({ params, successCallback }) {
            if (!this.isNewState(this.makeInvoiceStatus) || this.isEditHeader()) return;
            const addData = params.selected.map(item => {
                const resItem = {
                    ...item,
                    ...mergeMatchedKeys(item, saveDataTemp),
                    'sourceJobId': this.jobId
                };
                delete resItem.rentStartAndEndDate;
                return resItem;
            });
            if (this.invoiceLabelName === 'CBS') {
                for (let index = 0; index < addData.length; index++) {
                    const el = addData[index];
                    if (!(this.checkPlaceNameFn(el.placeFromAddress) && this.checkPlaceNameFn(el.placeToAddress))) {
                        return this.$message.warning('起运地和到达地必须含：' + this.addressKeywords + '，请检查修正后重试。');
                    }
                }
            } else if (this.invoiceLabelName === 'REBLS') {
                if (!this.checkAddressKeywordsFn({ address: params.selected[0].realEstateAddress.replace(/ \/ /g, '&'), detailedAddress: addData[0].detailedAddress })) return;
                addData[0].rentStartDate = params.selected[0].rentStartAndEndDate[0];
                addData[0].rentEndDate = params.selected[0].rentStartAndEndDate[1];
                // 处理不动产地址保存字符串格式
                addData[0].subStr2 = params.selected[0].subStr2 ? params.selected[0].subStr2.join(',') : [];
                addData[0].realEstateAddress = `${params.selected[0].realEstateAddress.replace(/ \/ /g, '&')},${params.selected[0].detailedAddress}`;
                delete addData[0].detailedAddress;
            };
            this.setBtnLoading('save', true);
            saveExtsysInvoiceInfo(addData).then(res => {
                if (res && +res.code === 0) {
                    successCallback(res);
                }
            }).finally(() => {
                this.setBtnLoading('save', false);
            });
        },
        // 删除发票内容确认执行
        deleteTableConfirmExecute({ params, confirmFn, successCallback }) {
            if (!this.isNewState(this.makeInvoiceStatus)) return;
            if (this.invoiceLabelName === 'CBS') {
                for (let index = 0; index < this.selected.length; index++) {
                    const el = this.selected[index];
                    // subStr1 生成途径 1-结算申请生成 2-手工新增
                    if (['1', 1].includes(el.subStr1)) {
                        return this.$message.warning(this.selected.length === 1 ? '删除失败，系统自动生成的发票内容，不能删除！' : `选中的第${index + 1}行是系统生成的，删除失败！`);
                    }
                }
            }
            confirmFn().then(() => {
                deleteExtsysInvoiceInfo(params.ids).then(res => {
                    if (res && +res.code === 0) {
                        successCallback();
                    }
                });
            });
        },
        handleExport(row) {
            this.setBtnLoading('export', true);
            exportExtsysInvoiceInfo({
                sourceJobId: this.jobId,
                invoiceLabel: this.invoiceLabel
            }).finally(() => {
                this.setBtnLoading('export', false);
            });
        },
        handleUpload(row) {
            if (!['CBS'].includes(this.invoiceLabelName)) {
                return this.$message.warning('当前发票标签不支持导入!');
            }
            if (!this.isNewState(this.makeInvoiceStatus) || this.isEditHeader()) return;
            this.$nextTick(() => {
                this.$refs.uploadInvoiceContent.triggerUpload();
            });
        },
        submitUpload(uploadData) {
            const file = new File([uploadData.file], uploadData.file.name, {
                type: uploadData.file.type
            });
            const formData = new FormData();
            formData.append('file', file);
            formData.append('sourceJobId', this.jobId);
            formData.append('invoiceLabel', this.invoiceLabel);
            this.setBtnLoading('upload', true);
            importExtsysInvoiceInfo(formData)
                .then(res => {
                    if (res && res.code === '0') {
                        this.$message.success('导入成功');
                        this.queryList();
                    } else {
                        this.$message.warning('导入失败');
                    }
                })
                .finally(() => { this.setBtnLoading('upload', false); });
        },
        validateForm(e) {
            // 验证系统生成的数据
            // eslint-disable-next-line no-unused-vars
            const checkSystemGenerationFn = () => {
                // subStr1 生成途径 1-结算申请生成 2-手工新增
                if (this.curRowSnapshoot && ['1', 1].includes(this.curRowSnapshoot.subStr1) && this.curRowSnapshoot[e.prop] !== e.val) {
                    // 校验不通过需改回原来的数据
                    e.row[e.prop] = this.curRowSnapshoot[e.prop];
                    return this.$message.warning('系统自动生成的发票内容，不能修改！');
                }
            };
            const verifyMap = {
                'transportPlateNo': () => {
                },
                'placeFromAddress': () => {
                },
                'placeToAddress': () => {
                }
            };
            verifyMap[e.prop] && verifyMap[e.prop]();
        },

        handleRowClick(rows) {
            this.curRowSnapshoot = JSON.parse(JSON.stringify(rows));
        },
        handleChange(e) {
            this.validateForm(e);
        },
        // 覆盖列 按钮
        colCovering() {
            if (document.querySelector('.my-col-covering-icon')) return;
            const that = this;
            const dom = document.querySelector('.CBS-invoice tr:first-child td:nth-last-child(2) .cell');
            dom && dom.insertAdjacentHTML('beforeend', '<i title="覆盖至整列" class="el-icon-tickets my-col-covering-icon"></i>');
            const newDom = document.querySelector('.el-icon-tickets.my-col-covering-icon');
            newDom.addEventListener('click', function() {
                that.totalData.forEach((el, i) => {
                    i > 0 && (el.bhsje = that.totalData[0].bhsje);
                });
            });
        },
        // 解决不动产地址选择器popover位置不对的问题
        addressCascaderPopoverPlacementRefresh() {
            this.$nextTick(() => {
                const elements = document.getElementsByClassName('m-address-cascader');
                // 遍历元素并绑定事件
                [...elements].forEach(function(element) {
                    element.addEventListener('click', function(event) {
                        // 处理点击事件
                        setTimeout(() => {
                            const mainDome = document.getElementsByClassName('el-main')[0];
                            const top = mainDome.scrollTop;
                            document.getElementsByClassName('el-main')[0].scrollTop = top - 0.0001;
                            document.getElementsByClassName('el-main')[0].scrollTop = top + 0.0001;
                        }, 1);
                    });
                });
            });
        },
        getControlParamAddresskeywords() {
            // 获取系统控制参数
            const formData = new FormData();
            formData.append('controlParam', 'BMS_INVOICE_ADDRESS_NAME_CHECK');
            getControlParam(formData).then(res => {
                if (res && res.code === '0') {
                    this.addressKeywords = res.data.value;
                } else {
                    this.addressKeywords = '省,市,区,县,街,路,村,乡,镇,道,巷,号,洲';
                }
            });
        }
    },
    created() {
        this.getControlParamAddresskeywords();
    }
};
</script>

<style lang="less" scoped>
.box-card{
    margin-bottom: 20px;

}
/deep/ .m-address-cascader{
    flex: 1;
}
.CBS-invoice /deep/ tr:first-child td:nth-last-child(2) .cell{
    > div{
        flex: 1;
    }
    display: flex;
    justify-content: space-between;
    align-items: center;
    .my-col-covering-icon{
        padding-left:5px;
        cursor: pointer;
    }
    .my-col-covering-icon::before{
        font-size: 26px;
    }
    .my-col-covering-icon:hover{
        color: #00BCBF;
    }
    .my-col-covering-icon:active{
        color: #00bcbfad;
    }
}
</style>
